var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 106.8 28.3",
    style: {
      enableBackground: "new 0 0 106.8 28.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#1D1D1B;stroke-width:0.1697;stroke-miterlimit:10;}\r\n\t.st1{fill:#1D1D1B;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 1.1,
    className: "st0",
    width: 25.8,
    height: 26.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.6,23.8L7.2,6.9H7.1c0,0.4,0.1,0.8,0.1,1.3c0,0.5,0,1.1,0.1,1.7c0,0.6,0,1.2,0,1.8v12H5.2V4.7h3.3l6,15.8 h0.1l6.1-15.8H24v19.1h-2.2V11.6c0-0.6,0-1.1,0-1.7c0-0.6,0-1.1,0.1-1.6c0-0.5,0.1-0.9,0.1-1.3h-0.1l-6.5,16.8H13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.2,4.1c0.4,0,0.7,0.1,0.9,0.3c0.3,0.2,0.4,0.6,0.4,1.1c0,0.5-0.1,0.8-0.4,1.1C30.9,6.9,30.6,7,30.2,7 c-0.4,0-0.7-0.1-0.9-0.4S28.9,6,28.9,5.6c0-0.5,0.1-0.8,0.4-1.1C29.6,4.3,29.9,4.1,30.2,4.1z M31.3,9.5v14.3h-2.2V9.5H31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.3,23.8h-2.2V3.5h2.2V23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.5,9.3c1.7,0,3,0.4,3.8,1.1c0.8,0.8,1.2,2,1.2,3.7v9.7h-1.6l-0.4-2.1h-0.1c-0.4,0.5-0.8,1-1.3,1.3 c-0.4,0.4-0.9,0.6-1.5,0.8c-0.6,0.2-1.3,0.3-2.1,0.3c-0.9,0-1.6-0.2-2.3-0.5c-0.7-0.3-1.2-0.8-1.6-1.4c-0.4-0.6-0.6-1.4-0.6-2.3 c0-1.4,0.6-2.5,1.7-3.3c1.1-0.8,2.8-1.2,5.2-1.3l2.5-0.1v-0.9c0-1.2-0.3-2.1-0.8-2.6c-0.5-0.5-1.3-0.7-2.2-0.7 c-0.7,0-1.5,0.1-2.1,0.3c-0.7,0.2-1.3,0.5-1.9,0.8l-0.7-1.6c0.6-0.3,1.4-0.6,2.2-0.8C46.7,9.4,47.6,9.3,48.5,9.3z M51.4,16.7 l-2.2,0.1c-1.8,0.1-3,0.4-3.8,0.9c-0.7,0.5-1.1,1.2-1.1,2.2c0,0.8,0.2,1.4,0.7,1.8c0.5,0.4,1.2,0.6,2,0.6c1.3,0,2.3-0.4,3.1-1.1 c0.8-0.7,1.2-1.8,1.2-3.2V16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65,9.2c1.7,0,3,0.4,3.8,1.2c0.9,0.8,1.3,2.2,1.3,4v9.3H68v-9.2c0-1.2-0.3-2.1-0.8-2.7 c-0.5-0.6-1.4-0.9-2.5-0.9c-1.6,0-2.7,0.4-3.3,1.3c-0.6,0.9-1,2.2-1,3.9v7.5h-2.2V9.5H60l0.3,2.1h0.1c0.3-0.5,0.7-0.9,1.2-1.3 c0.5-0.3,1-0.6,1.6-0.8C63.7,9.3,64.4,9.2,65,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.4,9.2c1.2,0,2.3,0.3,3.1,0.8c0.9,0.5,1.5,1.3,2,2.3c0.5,1,0.7,2.1,0.7,3.4V17h-9.9c0,1.7,0.4,3,1.3,3.8 c0.8,0.9,1.9,1.3,3.4,1.3c0.9,0,1.7-0.1,2.4-0.2c0.7-0.2,1.4-0.4,2.2-0.7v1.9c-0.7,0.3-1.4,0.6-2.1,0.7C82.7,24,81.9,24,80.9,24 c-1.4,0-2.6-0.3-3.6-0.8c-1-0.6-1.8-1.4-2.4-2.5c-0.6-1.1-0.8-2.4-0.8-4c0-1.5,0.3-2.9,0.8-4c0.5-1.1,1.2-2,2.2-2.6 C78,9.5,79.1,9.2,80.4,9.2z M80.3,11c-1.2,0-2.1,0.4-2.8,1.1c-0.7,0.8-1.1,1.8-1.2,3.2h7.6c0-0.9-0.1-1.6-0.4-2.2 c-0.3-0.6-0.6-1.2-1.2-1.5C81.8,11.2,81.2,11,80.3,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.4,19.9c0,0.9-0.2,1.7-0.7,2.3c-0.5,0.6-1.1,1.1-2,1.4c-0.8,0.3-1.9,0.5-3,0.5c-1,0-1.9-0.1-2.6-0.2 c-0.7-0.2-1.4-0.4-1.9-0.7v-2c0.6,0.3,1.3,0.5,2.1,0.8s1.6,0.4,2.5,0.4c1.2,0,2.1-0.2,2.7-0.6c0.6-0.4,0.8-0.9,0.8-1.6 c0-0.4-0.1-0.7-0.3-1c-0.2-0.3-0.6-0.6-1.1-0.9c-0.5-0.3-1.2-0.6-2.2-0.9c-0.9-0.3-1.7-0.7-2.4-1c-0.7-0.3-1.2-0.8-1.5-1.3 c-0.4-0.5-0.5-1.1-0.5-1.9c0-1.2,0.5-2.1,1.5-2.8c1-0.6,2.3-1,3.9-1c0.9,0,1.7,0.1,2.4,0.3c0.8,0.2,1.5,0.4,2.1,0.7l-0.7,1.7 c-0.6-0.3-1.2-0.5-1.9-0.6c-0.7-0.2-1.4-0.3-2-0.3c-1,0-1.8,0.2-2.3,0.5c-0.5,0.3-0.8,0.8-0.8,1.4c0,0.4,0.1,0.8,0.4,1.1 c0.2,0.3,0.6,0.6,1.2,0.8c0.5,0.3,1.3,0.5,2.2,0.9c0.9,0.3,1.7,0.7,2.3,1c0.7,0.4,1.2,0.8,1.5,1.3C99.2,18.4,99.4,19.1,99.4,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.2,4.1c0.4,0,0.7,0.1,0.9,0.3c0.3,0.2,0.4,0.6,0.4,1.1c0,0.5-0.1,0.8-0.4,1.1S104.6,7,104.2,7 c-0.4,0-0.7-0.1-0.9-0.4s-0.4-0.6-0.4-1.1c0-0.5,0.1-0.8,0.4-1.1C103.5,4.3,103.8,4.1,104.2,4.1z M105.3,9.5v14.3h-2.2V9.5H105.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a0b7a8d1067dc7465b19f2d8e8307ee9.svg";
export { ForwardRef as ReactComponent };